<template>
  <div class="multi-upload-field">
    <m4-upload-field v-for="row in rows" :key="row" v-bind="uploadFieldData(row)"></m4-upload-field>
    <m4-button @click="addFileClick" tag="a" size="sm" variant="info-outline">{{ addBtnTitle }}</m4-button>
  </div>
</template>

<script>
export default {
  name: "M4MultiUploadField",
  data() {
    return {
      rows: this.defaultFileNames && this.defaultFileNames.length ? this.defaultFileNames.length : 1
    };
  },
  props: {
    defaultFileNames: {
      type: Array
    },
    defaultInputNames: {
      type: Array
    },
    defaultInputIds: {
      type: Array
    },
    labelFileInput: {
      type: Array
    },
    downloadLinks: {
      type: Array
    },
    imgPaths: {
      type: Array
    },
    addBtnTitle: {
      type: String,
      default() {
        return "Add file";
      }
    }
  },
  computed: {
    currName() {
      return this.$attrs.name + "[]";
    }
  },
  methods: {
    addFileClick() {
      this.rows++;
    },
    uploadFieldData(row) {
      let attrs = this.$attrs;
      return Object.assign({}, attrs, {
        name: attrs.name + "__" + row,
        defaultFileName: this.uploadFieldValue(row, "defaultFileNames"),
        defaultInputName: this.uploadFieldValue(row, "defaultInputNames"),
        defaultInputId: this.uploadFieldValue(row, "defaultInputIds"),
        labelFileInput: this.uploadFieldValue(row, "defaultFileNames")
          ? "Replace uploaded document with:"
          : "Upload file:",
        downloadLink: this.uploadFieldValue(row, "downloadLinks"),
        imgPath: this.uploadFieldValue(row, "imgPaths")
      });
    },
    uploadFieldValue(row, fieldName) {
      return this[fieldName] && this[fieldName][row - 1] !== undefined ? this[fieldName][row - 1] : null;
    }
  }
};
</script>
